import styled from 'styled-components';

export const DemoFormWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: space-between;
        ${down(breakpoints.md)} {
            padding: 0 15px;
            flex-direction: column;
            justify-content: flex-start;
            margin-bottom: 30px;
            .succImg {
                width: 100%;
            }
        }
    `
);
